import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const StyledButton = styled(Button)(({ noWrap }) => ({
  borderRadius: 4,
  textTransform: 'none',
  fontWeight: 'medium',
  padding: '6px 16px',
  fontSize: '0.9rem',
  '&.MuiButton-sizeSmall': {
    padding: '4px 12px',
    fontSize: '0.8rem',
  },
  ...(noWrap && {
    whiteSpace: 'nowrap',
  }),
}));